import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { FEATURES } from "../../../utils/constant";
import { aesDecrypt } from "../../../utils/commonFunctionalities";

class Branch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ url: "branch/" })
      .then((dataArray) => {
        console.log(dataArray);
        let data=isEmpty(dataArray) ? [] : dataArray?.data?.resultSet?.map((element)=>{
          if(element.isGSTApplicable === 1){
            element = {...element,isGSTApplicable : "Yes"}
          }else {
            element = {...element,isGSTApplicable : "No"}
          }
          if(element.isGSTApplicable === "Yes" && element.isGSTExempted === 1){
            element = {...element,isGSTExempted : "Yes"}
          }else {
            element = {...element,isGSTExempted : "No"}
          } 

          if(element.gstNo) element.gstNo = aesDecrypt(element.gstNo);
          if(element.panNo) element.panNo = aesDecrypt(element.panNo);
          return element
        })
        this.setState({
          rowData: data,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_DRIVER_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-branch", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/branch");
    this.props.history.go();
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const Columns = [
      {
        headerName: t("table_header.code") || "Code",
        field: "branchCode",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.branch_name") || "Branch Name",
        field: "branchName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.city") || "City",
        field: "cityName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.address") || "Address",
        field: "address",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.gst_no") ||"GST Number",
        field: "gstNo",
        sortable: true,
        filter: true,
        hide: false,
      },
      {
        headerName: t("table_header.is_gst_applicable") ||"Is GST Applicable",
        field: "isGSTApplicable",
        sortable: true,
        filter: true,
        hide: false,
      },
      {
        headerName: t("table_header.is_gst_exempted") ||"Is GST Exempted",
        field: "isGSTExempted",
        sortable: true,
        filter: true,
        hide: false,
      },
      {
        headerName: t("table_header.service_category") ||"Service Category",
        field: "serviceCategory",
        sortable: true,
        filter: true,
        hide: false,
      },
      {
        headerName: t("table_header.cost_center") ||"Cost Center",
        field: "costCenter",
        sortable: true,
        filter: true,
        hide: false,
      },
      {
        headerName: t("table_header.contact_person_name") ||"Contact Person",
        field: "contactPersonName",
        sortable: true,
        filter: true,
        hide: false,
      },
      {
        headerName: t("table_header.contact_person_no") ||"Contact Person Number",
        field: "contactPersonMobileNo",
        sortable: true,
        filter: true,
        hide: false,
      },
      // {
        //   headerName: t("table_header.sim_card_provider") || "Sim Card Provider",
      //   field: "address",
      //   sortable: true,
      //   filter: true,
      //   hide: true,
      // },
      // {
      //   headerName: t("table_header.created_by") || "Created By",
      //   field: "createdBy",
      //   sortable: true,
      //   filter: true,
      // },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_by") || "Modified By",
        field: "updatedBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_on") || "Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_DRIVER_MASTER.UPDATE && !this.props.permissions.TA_DRIVER_MASTER.DELETE,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={this.props.t("title") || "Drivers"}
          titleBarLink={"/add-branch"}
          baseURL={"branchMaster"}
          pathName={"branchMaster"}
          keyIndex={"branchId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_DRIVER_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_DRIVER_MASTER.DELETE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("allbranch")(Branch));
